module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/4f78e2dbcd0ec251293e5a21bf3bec67.svg";